import React from 'react'

const BiasScanner = () => {
  return <div id='tandem-root'></div>
}

export default BiasScanner
